import { LedgerProvisioningStatusEnum, LedgerStatus } from '../../../cfo/models/ledger.models';
import { accountsMockResponses } from './ledger-mock-accounts';
import { MockResponse, ResponseStateEnum } from './mock.models';

const LEDGER_STATUS: LedgerStatus = {
  status: LedgerProvisioningStatusEnum.READY,
  targets: ['quickbooks'],
  entities: [
    {
      id: 1,
      name: 'Constrafor Demo LLC',
      entity_type: 'llc',
      status: LedgerProvisioningStatusEnum.READY,
      coa_template_version: '2026.1',
      provisioned_at: '2026-01-05T15:00:00Z',
      import: { source: 'quickbooks', cutover_date: '2026-01-01', status: 'completed' },
      last_error: null,
    },
  ],
  capabilities: ['journal_entries', 'reports', 'exports'],
  failed_entries: 0,
  max_account_depth: 1,
  links: { managed_bookkeeping: null },
};

export const ledgerMockResponses: MockResponse[] = [
  {
    state: ResponseStateEnum.SUCCESS,
    method: 'GET',
    path: '/cru/ledger/',
    response: { status: 200, body: LEDGER_STATUS },
  },
  ...accountsMockResponses,
];
